import React, { useEffect, useState } from 'react';

/**
 * XPToast — animated toast notification shown after earning XP.
 * Usage: <XPToast amount={50} onDone={() => setShowXP(false)} />
 */
const XPToast = ({ amount, reason, onDone }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onDone, 400);
    }, 2800);
    return () => clearTimeout(timer);
  }, [onDone]);

  const labels = {
    quiz_completion: '🧠 Kuiz i përfunduar!',
    srs_review:      '🃏 Rishikim SRS!',
    journal_entry:   '✍️ Ditar i shkruar!',
    timed_challenge: '⏱️ Sfidë e kohës!',
    exercise:        '💪 Ushtrim!',
    welcome_bonus:   '🎉 Mirë se erdhe!',
  };

  const label = labels[reason] || '⚡ Aktivitet i përfunduar!';

  return (
    <div
      className={`fixed bottom-6 right-6 z-[9999] transition-all duration-400 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
    >
      <div className="flex items-center gap-3 bg-zinc-900 text-white px-5 py-3.5 rounded-2xl shadow-2xl border border-zinc-700">
        <div className="flex flex-col">
          <span className="text-xs text-zinc-400 font-medium">{label}</span>
          <span className="text-2xl font-bold text-yellow-400">+{amount} XP</span>
        </div>
        <div className="w-10 h-10 bg-yellow-400/20 rounded-full flex items-center justify-center text-xl">
          🏆
        </div>
      </div>
    </div>
  );
};

export default XPToast;
